import { Injectable } from '@angular/core';

import { environment } from '../../../../environments/environment';
import { RecordingParserService } from './recording-parser.service';
import { IRecordingManager, OnRecording } from './recording-manager';

import { RoomManagerService } from '../room/room-manager.service';
import { SessionManagerService } from '../session/session-manager.service';
import { ReplayerService } from 'app/wb/player/replayer.service';
declare var chrome;
@Injectable()
export class RecordingManagerService implements IRecordingManager {
	public shouldRecord = false;
	public allowRecording = false;
	public showRecordingControls = true;
	
	constructor(private replayerService: ReplayerService, private parser: RecordingParserService, private sessionManager: SessionManagerService) {
		parser.setManager(this);
		
	}
	unregisterOnRecordingCallback(cb: OnRecording) {
		delete this.onRecordingCallbacks[cb.getId()];
	}
	onRecordingCallbacks = {};
	registerOnRecordingCallback(cb: OnRecording) {
		this.onRecordingCallbacks[cb.getId()] = cb;
	}

	sendRecording(recording, s, sessionId) {
		
		this.parser.sendRecording(recording, null, s, sessionId);//todo should send current record id not null or record container id
	}
	_isRecording = false;
	setRecording(to) {
		this._isRecording = to
	}
	isRecording() {
		return this._isRecording;
	}recordingFilename
	recordingStarted(recordId, filename) {
		this.setRecording(true);
		this.recordingFilename = filename;
		for (var c in this.onRecordingCallbacks) {
			this.onRecordingCallbacks[c].onRecordingStarted(recordId);
		}
		
		this.startCapture(filename);
	}
	recordingStopped(recordId) {
		this.setRecording(false);
		for (var c in this.onRecordingCallbacks) {
			this.onRecordingCallbacks[c].onRecordingStopped(recordId);
		}
		this.stopCapture();
	}
startCapture(filename){
this.capture(true, filename);
}
stopCapture(){
this.capture(false);
}
onDisconnected(){
	if (this.replayerService.extId){
		this.parser.close(true);
		this.stopCapture();
	}
}
capture(capture, filename=null){
	if (this.replayerService.extId){
		
		if(capture){
		console.log("Will try to start recording "+this.replayerService.extId+" and "+filename);
		}
		else{
			console.log("Will try to stop recording "+this.replayerService.extId);
		}
		var self = this;
		chrome.runtime.sendMessage(this.replayerService.extId, {
			text: capture?'start':'stop',
			filename: self.recordingFilename,
			hash: null//this.ws.hash
		  });
	}
}

	switchRecording() {
		if (!this.isRecording()) {
			var s = this.sessionManager.getCurrentStates(true);
			this.sendRecording(true, s, this.sessionManager.getCurrentSessionId());
		} else {
			this.sendRecording(false, null, this.sessionManager.getCurrentSessionId());
		}
	}

}



// WEBPACK FOOTER //
// /app/src/app/wb/services/recording/recording-manager.service.ts